import { render, staticRenderFns } from "./AutomaticLeadRulesNotice.vue?vue&type=template&id=b6998a7a&scoped=true"
import script from "./AutomaticLeadRulesNotice.vue?vue&type=script&lang=js"
export * from "./AutomaticLeadRulesNotice.vue?vue&type=script&lang=js"
import style0 from "./AutomaticLeadRulesNotice.vue?vue&type=style&index=0&id=b6998a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6998a7a",
  null
  
)

export default component.exports